import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type SightingLocation = {
  id: string;
  lat: number;
  lng: number;
  intensity: number;
  label: string;
  year: string;
  description: string;
  witness?: string | null;
};

export const useSightingLocations = () => {
  return useQuery({
    queryKey: ["sighting-locations"],
    queryFn: async (): Promise<SightingLocation[]> => {
      const { data, error } = await supabase
        .from("sighting_locations")
        .select("*")
        .order("year", { ascending: false })
        .order("label", { ascending: true });
      if (error) throw error;
      return data as SightingLocation[];
    },
  });
};

export type NewSightingLocation = Omit<SightingLocation, "witness"> & { witness?: string | null };

export const useBulkInsertSightings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (locations: NewSightingLocation[]) => {
      const { data, error } = await supabase
        .from("sighting_locations")
        .insert(locations)
        .select();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sighting-locations"] });
    },
  });
};
